
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground } from 'docz'
import placeholderImg from '../../../common/static/images/image/image-placeholder.svg'
import testImg from '../../static/images/logo/EIU-logo--horizontal.svg'
import Link from './link'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "link"
    }}>{`Link`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "link-1"
    }}>{`Link`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For providing users with a link to a new location.`}</p>
    <p><strong parentName="p">{`The component allows for different content within the link: simple text, headings and other markup.`}</strong></p>
    <p><strong parentName="p">{`The default state (set with prop `}<inlineCode parentName="strong">{`type`}</inlineCode>{`) provides styles and link pseudo-states.`}</strong></p>
    <Playground __position={1} __code={'<code>\n  <Link href=\"http://viewswire.eiu.com/\">Link with simple text</Link>\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      placeholderImg,
      testImg,
      Link
    }} mdxType="Playground">
  <code>
    <Link href="http://viewswire.eiu.com/" mdxType="Link">Link with simple text</Link>
  </code>
    </Playground>
    <p><strong parentName="p">{`With a heading`}</strong></p>
    <Playground __position={2} __code={'<code>\n  <Link href=\"http://viewswire.eiu.com/\">\n    <h5>Link with heading</h5>\n  </Link>\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      placeholderImg,
      testImg,
      Link
    }} mdxType="Playground">
  <code>
    <Link href="http://viewswire.eiu.com/" mdxType="Link"><h5>Link with heading</h5></Link>
  </code>
    </Playground>
    <p><strong parentName="p">{`With `}<inlineCode parentName="strong">{`<span>`}</inlineCode>{` markup`}</strong></p>
    <Playground __position={3} __code={'<code>\n  <Link href=\"http://viewswire.eiu.com/\" type=\"default\">\n    <span\n      style={{\n        border: \'0.0625rem solid #333\',\n        margin: \'-1em\',\n        padding: \'1em\',\n      }}\n    >\n      <img\n        style={{ height: \'6.75rem\', margin: \'0 0 1rem 0\', width: \'12rem\' }}\n        src={placeholderImg}\n        alt=\"clickable image\"\n      />\n      <p>Example text</p>\n    </span>\n  </Link>\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      placeholderImg,
      testImg,
      Link
    }} mdxType="Playground">
  <code>
    <Link href="http://viewswire.eiu.com/" type="default" mdxType="Link">
      <span style={{
            border: "0.0625rem solid #333",
            margin: '-1em',
            padding: '1em'
          }}>
        <img style={{
              height: '6.75rem',
              margin: '0 0 1rem 0',
              width: '12rem'
            }} src={placeholderImg} alt="clickable image" />
        <p>Example text</p>
      </span>
    </Link>
  </code>
    </Playground>
    <hr />
    <h2 {...{
      "id": "link-custom"
    }}>{`Link (custom)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For providing users with a link to a new location.`}</p>
    <p><strong parentName="p">{`The custom state (set with prop `}<inlineCode parentName="strong">{`type`}</inlineCode>{`) provides a focus pseudo-state only. Hover, active and visited states are not explicity defined, and will inherit browser behaviours.`}</strong></p>
    <Playground __position={5} __code={'<code>\n  <Link href=\"http://viewswire.eiu.com/\" type=\"custom\">\n    <img\n      style={{ height: \'auto\', width: \'12rem\' }}\n      src={testImg}\n      alt=\"Placeholder image\"\n    />\n  </Link>\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      placeholderImg,
      testImg,
      Link
    }} mdxType="Playground">
  <code>
    <Link href="http://viewswire.eiu.com/" type="custom" mdxType="Link"><img style={{
            height: 'auto',
            width: '12rem'
          }} src={testImg} alt="Placeholder image" /></Link>
  </code>
    </Playground>
    <p><strong parentName="p">{`With `}<inlineCode parentName="strong">{`<section>`}</inlineCode>{` markup`}</strong></p>
    <Playground __position={6} __code={'<code>\n  <Link href=\"http://viewswire.eiu.com/\" type=\"custom\">\n    <section\n      style={{ border: \'1px solid #333\', margin: \'-2em\', padding: \'2em\' }}\n    >\n      <h5>Link with heading</h5>\n      <p>Link paragraph content</p>\n    </section>\n  </Link>\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      placeholderImg,
      testImg,
      Link
    }} mdxType="Playground">
  <code>
    <Link href="http://viewswire.eiu.com/" type="custom" mdxType="Link"><section style={{
            border: "1px solid #333",
            margin: '-2em',
            padding: '2em'
          }}><h5>Link with heading</h5><p>Link paragraph content</p></section></Link>
  </code>
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;